import axios from "axios";
import LocalStorage from "../../localStorage";
import {loggedOut} from "../auth";


export const GET_EVENT_REQUEST = 'GET_EVENT_REQUEST';
export const GET_EVENT_SUCCESS = 'GET_EVENT_SUCCESS';
export const GET_EVENT_FAILURE = 'GET_EVENT_FAILURE';

const localStorageService = LocalStorage.getService();

export const getEventRequest = () => {
    return { type: GET_EVENT_REQUEST }
};

export const getEventSuccess = (events = {}) => {
    return { type: GET_EVENT_SUCCESS, events }
};

export const getEventFailure = (error) => {
    return { type: GET_EVENT_FAILURE, error }
};

export const startGetEvent = () => {
    console.log('Start startGetEvent');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getEventRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/event?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response event: ", response.data);
                    dispatch(getEventSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if (error.response.status === 401) dispatch(loggedOut());
                dispatch(getEventFailure(error));
            });
    };
};
